var map = {
	"./TFT9_Aatrox.TFT_Set9.webp": 6708,
	"./TFT9_Ahri.TFT_Set9.webp": 6377,
	"./TFT9_Akshan.TFT_Set9.webp": 2961,
	"./TFT9_Aphelios.TFT_Set9.webp": 9439,
	"./TFT9_Ashe.TFT_Set9.webp": 4547,
	"./TFT9_Azir.TFT_Set9.webp": 7549,
	"./TFT9_BaronNashor.TFT_Set9.webp": 9811,
	"./TFT9_Belveth.TFT_Set9.webp": 8358,
	"./TFT9_Cassiopeia.TFT_Set9.webp": 5466,
	"./TFT9_Chogath.TFT_Set9.webp": 1018,
	"./TFT9_Darius.TFT_Set9.webp": 2460,
	"./TFT9_Ekko.TFT_Set9.webp": 2507,
	"./TFT9_Galio.TFT_Set9.webp": 8099,
	"./TFT9_Garen.TFT_Set9.webp": 9451,
	"./TFT9_Gwen.TFT_Set9.webp": 9205,
	"./TFT9_Heimerdinger.TFT_Set9.webp": 9211,
	"./TFT9_Irelia.TFT_Set9.webp": 950,
	"./TFT9_Jarvaniv.TFT_Set9.webp": 1697,
	"./TFT9_Jayce.TFT_Set9.webp": 14,
	"./TFT9_Jhin.TFT_Set9.webp": 9040,
	"./TFT9_Jinx.TFT_Set9.webp": 6307,
	"./TFT9_Kaisa.TFT_Set9.webp": 6013,
	"./TFT9_Kalista.TFT_Set9.webp": 2853,
	"./TFT9_Karma.TFT_Set9.webp": 5946,
	"./TFT9_Kassadin.TFT_Set9.webp": 4696,
	"./TFT9_Katarina.TFT_Set9.webp": 9932,
	"./TFT9_Kayle.TFT_Set9.webp": 8506,
	"./TFT9_Kled.TFT_Set9.webp": 8535,
	"./TFT9_Ksante.TFT_Set9.webp": 5104,
	"./TFT9_Lissandra.TFT_Set9.webp": 9357,
	"./TFT9_Lux.TFT_Set9.webp": 8459,
	"./TFT9_Malzahar.TFT_Set9.webp": 1197,
	"./TFT9_Maokai.TFT_Set9.webp": 4840,
	"./TFT9_Nasus.TFT_Set9.webp": 5973,
	"./TFT9_Orianna.TFT_Set9.webp": 9797,
	"./TFT9_Poppy.TFT_Set9.webp": 5854,
	"./TFT9_Reksai.TFT_Set9.webp": 3588,
	"./TFT9_Renekton.TFT_Set9.webp": 8823,
	"./TFT9_Ryze.TFT_Set9.webp": 1170,
	"./TFT9_Samira.TFT_Set9.webp": 5588,
	"./TFT9_Sejuani.TFT_Set9.webp": 6352,
	"./TFT9_Senna.TFT_Set9.webp": 4182,
	"./TFT9_Sett.TFT_Set9.webp": 7154,
	"./TFT9_Shen.TFT_Set9.webp": 4327,
	"./TFT9_Sion.TFT_Set9.webp": 8426,
	"./TFT9_Sona.TFT_Set9.webp": 7400,
	"./TFT9_Soraka.TFT_Set9.webp": 2435,
	"./TFT9_Swain.TFT_Set9.webp": 670,
	"./TFT9_Taliyah.TFT_Set9.webp": 5873,
	"./TFT9_Taric.TFT_Set9.webp": 9214,
	"./TFT9_Teemo.TFT_Set9.webp": 2341,
	"./TFT9_Tristana.TFT_Set9.webp": 4409,
	"./TFT9_Urgot.TFT_Set9.webp": 3713,
	"./TFT9_Velkoz.TFT_Set9.webp": 7914,
	"./TFT9_Vi.TFT_Set9.webp": 3076,
	"./TFT9_Viego.TFT_Set9.webp": 547,
	"./TFT9_Warwick.TFT_Set9.webp": 6096,
	"./TFT9_Yasuo.TFT_Set9.webp": 3601,
	"./TFT9_Zed.TFT_Set9.webp": 866,
	"./TFT9_Zeri.TFT_Set9.webp": 7940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4101;